import { Squares2X2Icon } from "@heroicons/react/24/outline"
import RelatedTab from "./RelatedTab"

/**
 * Related extension (admin side): two product pickers — related and
 * cross-sell. The server half is aldoo-na/store/product/extensions/related
 * (it sends the storefront the linked products as cards).
 */
export const StoreProductExtension = {
  id: "related",
  label: "Related Products",
  description: "Hand-picked related and cross-sell products",
  section: {
    component: RelatedTab,
    label: "Related",
    icon: Squares2X2Icon,
    order: 750,
  },
}
